/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationPractitioner } from './HomeHealthCertificationPractitioner';
import {
    HomeHealthCertificationPractitionerFromJSON,
    HomeHealthCertificationPractitionerFromJSONTyped,
    HomeHealthCertificationPractitionerToJSON,
    HomeHealthCertificationPractitionerToJSONTyped,
} from './HomeHealthCertificationPractitioner';
import type { HomeHealthCertificationReferralOrderDisciplines } from './HomeHealthCertificationReferralOrderDisciplines';
import {
    HomeHealthCertificationReferralOrderDisciplinesFromJSON,
    HomeHealthCertificationReferralOrderDisciplinesFromJSONTyped,
    HomeHealthCertificationReferralOrderDisciplinesToJSON,
    HomeHealthCertificationReferralOrderDisciplinesToJSONTyped,
} from './HomeHealthCertificationReferralOrderDisciplines';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationSignature } from './HomeHealthCertificationSignature';
import {
    HomeHealthCertificationSignatureFromJSON,
    HomeHealthCertificationSignatureFromJSONTyped,
    HomeHealthCertificationSignatureToJSON,
    HomeHealthCertificationSignatureToJSONTyped,
} from './HomeHealthCertificationSignature';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationReferralOrder
 */
export interface HomeHealthCertificationReferralOrder {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationReferralOrder
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationReferralOrder
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationReferralOrder
     */
    order_date: string;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationReferralOrder
     */
    order_form: HomeHealthCertificationReferralOrderOrderFormEnum;
    /**
     * 
     * @type {HomeHealthCertificationPractitioner}
     * @memberof HomeHealthCertificationReferralOrder
     */
    ordering_practitioner: HomeHealthCertificationPractitioner;
    /**
     * 
     * @type {HomeHealthCertificationSignature}
     * @memberof HomeHealthCertificationReferralOrder
     */
    order_signature: HomeHealthCertificationSignature;
    /**
     * 
     * @type {HomeHealthCertificationReferralOrderDisciplines}
     * @memberof HomeHealthCertificationReferralOrder
     */
    disciplines: HomeHealthCertificationReferralOrderDisciplines;
    /**
     * 
     * @type {Array<HomeHealthCertificationReference>}
     * @memberof HomeHealthCertificationReferralOrder
     */
    ref: Array<HomeHealthCertificationReference>;
}


/**
 * @export
 */
export const HomeHealthCertificationReferralOrderOrderFormEnum = {
    Written: 'written',
    Verbal: 'verbal',
    Attestation: 'attestation',
    Unknown: 'unknown'
} as const;
export type HomeHealthCertificationReferralOrderOrderFormEnum = typeof HomeHealthCertificationReferralOrderOrderFormEnum[keyof typeof HomeHealthCertificationReferralOrderOrderFormEnum];


/**
 * Check if a given object implements the HomeHealthCertificationReferralOrder interface.
 */
export function instanceOfHomeHealthCertificationReferralOrder(value: object): value is HomeHealthCertificationReferralOrder {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('order_date' in value) || value['order_date'] === undefined) return false;
    if (!('order_form' in value) || value['order_form'] === undefined) return false;
    if (!('ordering_practitioner' in value) || value['ordering_practitioner'] === undefined) return false;
    if (!('order_signature' in value) || value['order_signature'] === undefined) return false;
    if (!('disciplines' in value) || value['disciplines'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationReferralOrderFromJSON(json: any): HomeHealthCertificationReferralOrder {
    return HomeHealthCertificationReferralOrderFromJSONTyped(json, false);
}

export function HomeHealthCertificationReferralOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationReferralOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'order_date': json['order_date'],
        'order_form': json['order_form'],
        'ordering_practitioner': HomeHealthCertificationPractitionerFromJSON(json['ordering_practitioner']),
        'order_signature': HomeHealthCertificationSignatureFromJSON(json['order_signature']),
        'disciplines': HomeHealthCertificationReferralOrderDisciplinesFromJSON(json['disciplines']),
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
    };
}

export function HomeHealthCertificationReferralOrderToJSON(json: any): HomeHealthCertificationReferralOrder {
    return HomeHealthCertificationReferralOrderToJSONTyped(json, false);
}

export function HomeHealthCertificationReferralOrderToJSONTyped(value?: HomeHealthCertificationReferralOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'order_date': value['order_date'],
        'order_form': value['order_form'],
        'ordering_practitioner': HomeHealthCertificationPractitionerToJSON(value['ordering_practitioner']),
        'order_signature': HomeHealthCertificationSignatureToJSON(value['order_signature']),
        'disciplines': HomeHealthCertificationReferralOrderDisciplinesToJSON(value['disciplines']),
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
    };
}

